<template>
  <tr class="contact-persons-list-item">
    <td class="align-middle">
      <d-badge
        v-if="contactData.is_default"
        theme="dark"
        :outline="true">
        Default contact person
      </d-badge>
      <a
        v-else
        href="#"
        @click="setAsDefaultContactPerson(contactData.id)"
        :class="{
          'is-locked': setAsDefaultInProgress
        }">
        <span
          v-if="setAsDefaultInProgress === contactData.id"
          class="spinner-item"></span>
        Set as default
      </a>
    </td>
    <td class="align-middle">
      {{ contactData.first_name }}
    </td>
    <td class="align-middle">
      {{ contactData.last_name }}
    </td>
    <td class="align-middle">
      {{ contactData.company }}
    </td>
    <td class="align-middle">
      {{ contactData.email }}
    </td>
    <td class="align-middle">
      <d-button
        theme="primary"
        @click.prevent="editContactPerson"
        class="mr-2"
        title="Edit">
        <i class="material-icons">edit</i>
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeContactPerson"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'israel-contact-persons-list-item',
  props: {
    contactData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false,
      setAsDefaultInProgress: false
    };
  },
  methods: {
    removeContactPerson () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/israel-contact-persons/delete/',
        id: parseInt(this.contactData.id, 10),
        successTitle: 'Contact person removed',
        successText: 'The selected contact person has been removed',
        confirmTitle: 'Do you really want to remove this contact person?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('israel-contact-persons-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editContactPerson () {
      this.$bus.$emit('show-israel-contact-person-popup', 'edit', this.contactData.id);
    },
    setAsDefaultContactPerson (contactPersonID) {
      if (this.setAsDefaultInProgress) {
        return;
      }

      this.setAsDefaultInProgress = contactPersonID;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/israel-contact-persons/set-as-default/' + contactPersonID,
        formData: null,
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during submitting data. Please try again.',
        successAction: () => {
          this.setAsDefaultInProgress = false;
          this.$bus.$emit('israel-contact-persons-list-reload', 'passports');
        },
        failAction: () => {
          this.setAsDefaultInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-persons-list-item {
  .is-locked {
    opacity: .5;
    pointer-events: none;
  }

  /deep/ .spinner-item {
    display: inline-block;
    height: 16px;
    width: 16px;
    animation: rotate 0.8s infinite linear;
    border: 2px solid #84899e;
    border-right-color: transparent;
    border-radius: 50%;
    position: relative;
    top: 2px;
  }
}

@keyframes rotate {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}
</style>
